<template>
  <vs-prompt
    :title="titleText"
    @cancel="val = ''"
    @accept="onAccept"
    :active.sync="addNewCampaignPrompt"
    :accept-text="titleText"
    :is-valid="validForm"
  >
    <div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Title</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-input
            class="inputx w-full"
            placeholder="Title"
            v-model="campaign_title"
          />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Category</span>
        </div>

        <div class="vx-col sm:w-2/5">
          <vs-select v-model="campaign_category">
            <vs-select-item
              :key="index"
              :value="item"
              :text="item"
              v-for="(item, index) in category_list"
            />
          </vs-select>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Description</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-textarea
            v-model="campaign_description"
            placeholder="Description"
            class="w-full"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Date</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-select label="Month" v-model="month">
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.name"
              v-for="(item, index) in selectableMonths"
            />
          </vs-select>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-select label="Year" v-model="year">
            <vs-select-item
              :key="curYear"
              :value="curYear"
              :text="curYear"
              v-for="curYear in selectableYears"
            />
          </vs-select>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Starred</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-checkbox v-model="campaign_starred" class="w-full" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Color</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <ul class="color-select">
            <li
              v-for="color in selectableColors"
              :key="color"
              @click="campaign_color = color"
            >
              <div :class="{ selected: campaign_color == color }"></div>
            </li>
          </ul>
        </div>
      </div>

      <vs-divider v-if="campaign_isHQ" />

      <div class="vx-row mb-6" v-if="campaign_isHQ">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Venues</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-select
            multiple
            class="selectVenue"
            style="width: 100%"
            v-model="selectedVenues"
          >
            <div :key="index" v-for="(item, index) in selectableVenues">
              <vs-select-group :title="item.title" v-if="item.group">
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in item.group"
                />
              </vs-select-group>
            </div>
          </vs-select>
        </div>
        <!-- TODO Buttons here to select all Danmark, Norge or Finland -->
      </div>

      <vs-button
        class="button-footer-left"
        v-if="campaign_id !== ''"
        color="danger"
        @click="confirmDelete"
        type="border"
        >Delete</vs-button
      >
    </div>
  </vs-prompt>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  data() {
    return {
      campaign_isHQ: false,
      campaign_id: "",
      campaign_title: "",
      campaign_category: "",
      campaign_description: "",
      campaign_color: "",
      campaign_starred: false,
      event_tags: [],
      addNewCampaignPrompt: false,
      year: -1,
      month: -1,
      category_list: [
        "REKOM initiatives",
        "RGB",
        "NightPay",
        "Supplier ",
        "Mega Events",
        "Other",
      ],
      selectableColors: [
        "#cccccc",
        "#cea8bc",
        "#a9c3c8",
        "#bcd611",
        "#de9c9b",
        "#fbe6a2",
        "#aac1f0",
        "#b2a7d2",
        "#bc4b31",
        "#111111",
      ],
      selectedVenues: [],
      selectableMonths: [
        { name: "January", value: 1 },
        { name: "February", value: 2 },
        { name: "March", value: 3 },
        { name: "April", value: 4 },
        { name: "May", value: 5 },
        { name: "June", value: 6 },
        { name: "July", value: 7 },
        { name: "August", value: 8 },
        { name: "September", value: 9 },
        { name: "October", value: 10 },
        { name: "November", value: 11 },
        { name: "December", value: 12 },
      ],
      selectableYears: Array.from(Array(7).keys()).map(
        (e) => e - 3 + new Date().getFullYear()
      ),
    };
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      userId: "users/userId",
      venues: "venues/venues",
    }),
    validForm() {
      return this.campaign_title !== "" && this.campaign_category !== "";
    },
    titleText() {
      const HQText = this.campaign_isHQ ? "HQ " : "";
      return (
        (this.campaign_id !== "" ? "Update " : "Add ") + HQText + "Campaign"
      );
    },
    selectableVenues() {
      return _.chain(this.venues)
        .map((e) => {
          return { ...e, text: e.name, value: e.venueId };
        })
        .groupBy((e) => e.country)
        .map((v, k) => {
          //console.log("Name: ", k, "value", v)
          return { title: k, group: v };
        })
        .value();
    },
  },
  methods: {
    confirmDelete() {
      this.addNewCampaignPrompt = false;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Delete Campaign?",
        accept: this.delete,
      });
    },
    async delete() {
      console.log("Deleting campaign");
      this.$vs.loading();
      await this.$store.dispatch("activationPlan/deleteCampaign", {
        campaignId: this.campaign_id,
        venueId: this.activeVenue.venueId,
        refreshHQ: this.campaign_isHQ,
      });

      this.$vs.loading.close();
      this.$vs.notify({
        color: "danger",
        title: "Deleted Campaign",
        text: "The campaign was deleted",
      });
    },
    show(year, month, isHQ = false) {
      this.year = year;
      this.month = month;
      this.campaign_isHQ = isHQ;

      this.campaign_color = "#cccccc";
      this.addNewCampaignPrompt = true;

      // Reset form
      this.campaign_id = "";
      this.campaign_title = "";
      this.campaign_category = "";
      this.campaign_description = "";
      this.campaign_starred = false;
      this.event_tags = [];
      this.selectedVenues = [this.activeVenue.venueId];
    },
    showWith(data, year, month) {
      this.campaign_isHQ = data.isHQ;
      this.selectedVenues = data.hqVenueIds;
      this.year = year;
      this.month = month;

      this.campaign_id = data.id;
      this.campaign_title = data.title;
      this.campaign_category = data.category;
      this.campaign_description = data.description;
      this.campaign_starred = data.starred;
      this.campaign_color = data.color;
      this.addNewCampaignPrompt = true;
    },
    async onAccept() {
      const campaign = {
        isHQ: this.campaign_isHQ,
        hqVenueIds: this.selectedVenues,
        title: this.campaign_title,
        category: this.campaign_category,
        description: this.campaign_description,
        color: this.campaign_color,
        starred: this.campaign_starred,
        year: this.year,
        month: this.month,
        venueId: this.activeVenue.venueId,
      };

      this.$vs.loading();
      if (this.campaign_id !== "") {
        campaign.id = this.campaign_id;
        console.log("Updating campaign", campaign);
        await this.$store.dispatch("activationPlan/updateCampaign", {
          campaign,
          venueId: this.activeVenue.venueId,
        });
        this.$vs.notify({
          color: "success",
          title: "Campaign updated",
          text: "Your campaign was updated",
        });
      } else {
        console.log("Adding campaign", campaign);
        await this.$store.dispatch("activationPlan/addCampaign", {
          campaign,
          venueId: this.activeVenue.venueId,
        });
        this.$vs.notify({
          color: "success",
          title: "Campaign added",
          text: "Your campaign was added",
        });
      }
      this.$vs.loading.close();
    },
  },
};
</script>

<style lang="scss">
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.vs-dialog {
  .after {
    background: rgba(0, 0, 0, 0) !important;
  }
  position: relative;
}

.button-footer-left {
  position: absolute;
  bottom: 14px;
  z-index: 100;
  animation: fadeIn ease 500ms forwards;
  animation-delay: 500ms;
  opacity: 0;
}
.con-vs-dialog .vs-dialog {
  max-width: 600px;
}
.vs-select--label {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6) !important;
}

.color-select {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  li {
    position: relative;
    width: 20px;
    height: 20px;
    margin: 10px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    $colors: (
      #cccccc,
      #cea8bc,
      #a9c3c8,
      #bcd611,
      #de9c9b,
      #fbe6a2,
      #aac1f0,
      #b2a7d2,
      #bc4b31,
      #111111
    );
    @for $i from 1 through length($colors) {
      &:nth-child(#{$i}) {
        background-color: nth($colors, $i);
        box-shadow: 0px 8px 12px -6px lighten(nth($colors, $i), 0.9);
      }
    }

    .selected {
      position: absolute;
      display: block;
      border-radius: 50%;
      border: 3px solid black;
      width: 32px;
      height: 32px;
    }
  }
}
</style>
